import React from 'react';
import {Redirect} from 'react-router-dom';

const SpiideoIndex = () => (
    <Redirect to='/spiideo-mappings/competitors'/>
);

SpiideoIndex.displayName = 'SpiideoIndex';

export default SpiideoIndex;
